import { appStoreLenses } from 'root/src/client/logic/app/lenses'
import prop from 'ramda/src/prop'

const { viewCreatorData } = appStoreLenses

export default state => prop('isTokenInvalid', viewCreatorData(state))
